(function () {
 
  const nativeSelector = '.js-ajax-add-to-cart'; 
  const stickyContainer = document.getElementById('sticky-add-to-cart');
  const stickyButton = document.getElementById('sticky-btn');
  const showWhenAnyNativeHidden = true; 
  const MAX_WIDTH = 989;

  function isElementInViewport(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }


  function showSticky() {
    stickyContainer.classList.add('is-visible');
    stickyContainer.setAttribute('aria-hidden', 'false');
  }
  function hideSticky() {
    stickyContainer.classList.remove('is-visible');
    stickyContainer.setAttribute('aria-hidden', 'true');
  }

  
  function updateStickyVisibility(nativeButtons) {
    if (window.innerWidth > MAX_WIDTH) {
      hideSticky();
      return;
    }
    if (!nativeButtons || nativeButtons.length === 0) {
      showSticky();
      return;
    }

   
    let anyVisible = false;
    for (let i = 0; i < nativeButtons.length; i++) {
      const el = nativeButtons[i];
      const observed = el.dataset._isInViewport;
      if (observed === 'true' || (observed === undefined && isElementInViewport(el))) {
        anyVisible = true;
        break;
      }
    }

    if (anyVisible) hideSticky();
    else showSticky();
  }

  const nativeButtons = Array.prototype.slice.call(document.querySelectorAll(nativeSelector));
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        entry.target.dataset._isInViewport = entry.isIntersecting ? 'true' : 'false';
      });

   
      updateStickyVisibility(nativeButtons);
    }, {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.01, 0.5, 1] 
    });

    nativeButtons.forEach(el => observer.observe(el));
  } else {
   
    const throttledCheck = throttle(() => updateStickyVisibility(nativeButtons), 150);
    window.addEventListener('scroll', throttledCheck, { passive: true });
    window.addEventListener('resize', throttledCheck);
    throttledCheck();
  }


  const domObserver = new MutationObserver(() => {
    const updated = Array.prototype.slice.call(document.querySelectorAll(nativeSelector));
    nativeButtons.length = 0;
    Array.prototype.push.apply(nativeButtons, updated);
    updateStickyVisibility(nativeButtons);
  });
  domObserver.observe(document.body, { childList: true, subtree: true });

  
  stickyButton.addEventListener('click', function (e) {
    e.preventDefault();
   
    const firstNative = document.querySelector(nativeSelector);
    if (firstNative) {
     
      try {
        firstNative.click();
        return;
      } catch (err) {
       
      }
    }

    const evt = new CustomEvent('sticky:add-to-cart', {
      detail: { message: 'sticky add to cart clicked' }
    });
    window.dispatchEvent(evt);

   
  });

  function throttle(fn, wait) {
    let last = 0, timer = null;
    return function () {
      const now = Date.now();
      const args = arguments;
      if (now - last >= wait) {
        last = now;
        fn.apply(this, args);
      } else {
        clearTimeout(timer);
        timer = setTimeout(() => {
          last = Date.now();
          fn.apply(this, args);
        }, wait - (now - last));
      }
    };
  }
  window.addEventListener('resize', function () {
    updateStickyVisibility(nativeButtons);
  });
  updateStickyVisibility(nativeButtons);

})();